import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use((r) => r, (error) => {
  if (error?.response?.status === 402 && typeof window !== "undefined") {
    const path = window.location.pathname;
    if (!path.startsWith("/precios") && !path.startsWith("/suscripcion")) {
      window.location.href = "/precios";
    }
  }
  return Promise.reject(error);
});

export default client;

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(", ");
  if (d && typeof d.msg === "string") return d.msg;
  return e?.message || "Ha ocurrido un error";
}

export function photoUrl(photoId) {
  const token = localStorage.getItem("token");
  return `${API}/photos/${photoId}/download?auth=${token}`;
}

export function signatureUrl(consentId) {
  const token = localStorage.getItem("token");
  return `${API}/consents/${consentId}/signature?auth=${token}`;
}
